var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noScan"},[_c('img',{attrs:{"src":require("../../assets/img/404/404.png")}}),_c('p',[_vm._v(" 岳阳地区代理人销售通道还未开放，敬请期待 ")])])}]

export { render, staticRenderFns }